import {css} from '@emotion/css';

import {mq, Breakpoints} from '../../../../styles/js/mixins';
import {colours, spacing} from '../../../../styles/js/variables';

const styles = {
  headerMainBar: css`
    label: headerMainBar;
    padding: ${spacing.XXS} 0;
    border-bottom: 1px solid ${colours.border.SEPARATOR_OFF_WHITE};
  `,
  container: css`
    label: headerMainBar__container;
    display: flex;
    align-items: center;
    min-height: 4.5rem;
    margin: 0 auto;
    padding: 0 ${spacing.XXS};

    ${mq(Breakpoints.DESKTOP)} {
      max-width: ${Breakpoints.DESKTOP_LG / 10}rem;
    }
  `,
  logoContainer: css`
    label: headerMainBar__logoContainer;
    margin-right: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      margin-right: ${spacing.XL};
    }
  `,
  logo: css`
    label: headerMainBar__logo;
    width: auto;
    height: 4rem;
    vertical-align: middle;
  `,
  links: css`
    label: headerMainBar__links;
    display: none;

    ${mq(Breakpoints.DESKTOP)} {
      display: initial;
    }
  `,
  link: css`
    label: headerMainBar__link;
    padding-right: 1.5rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    padding-left: 1.5rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    color: ${colours.font.BLACK};
    text-decoration: none;

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
    }
  `,
  right: css`
    label: headerMainBar__right;
    display: flex;
    align-items: center;
    margin-left: auto;
  `,

  menuButton: css`
    label: headerMainBar__menuButton;
    padding-right: ${spacing.XS};
    padding-left: ${spacing.XS};
  `,

  user: css`
    label: headerMainBar__user;
    margin-left: ${spacing.XXS};
  `,

  account: css`
    label: headerMainBar__account;
    display: flex;
    align-items: center;
  `,

  accountMessage: css`
    label: headerMainBar__accountMessage;
    margin-right: ${spacing.XXS};
    margin-bottom: 0;
  `,

  login: css`
    label: headerMainBar__login;
    margin-left: ${spacing.XXS};
  `,
};

export default styles;
